import { useState } from 'react';

import { useDebounce } from '@/shared/hooks/use-debounce/use-debounce';

export const useSearchableSelect = <TOptionShape>(
  onSelectChange?: (
    selectedOptions: TOptionShape[],
    value: TOptionShape | TOptionShape[],
    setValue: (value: TOptionShape | TOptionShape[]) => void,
  ) => void,
) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [shouldSearch, setShouldSearch] = useState(true);
  const debouncedSearch = useDebounce({
    value: shouldSearch ? inputValue : '',
  });

  const handleInputChange = (
    _: unknown,
    newInputValue: string,
    reason: string,
  ) => {
    if (reason === 'input') {
      setInputValue(newInputValue);
      setShouldSearch(true);
    }
  };

  const handleSelectChange = (
    selectedOptions: TOptionShape[],
    value: TOptionShape | TOptionShape[],
    setValue: (value: TOptionShape | TOptionShape[]) => void,
  ) => {
    setShouldSearch(false);
    if (onSelectChange) {
      onSelectChange(selectedOptions, value, setValue);
    }
  };

  return {
    inputValue,
    shouldSearch,
    debouncedSearch,
    handleSelectChange,
    handleInputChange,
  };
};
